import { useState } from "react";
import "./FounderBox.css";

const FounderBox = ({ photo, name, role, bio }) => {
  const [expanded, setExpanded] = useState(false);
  const contentId = `bio-${name?.replace(/\s+/g, "-").toLowerCase()}`;

  return (
    <div className="founder-box">
        <img
          src={photo}
          alt={`${name} headshot`}
          onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
      <div className="founder-header">
        <h2>{name}</h2>
        <h3 className="role">{role}</h3>
      </div>
      <hr class="black-divider-h"></hr>
      <button
        className="toggle-button"
        aria-expanded={expanded}
        aria-controls={contentId}
        onClick={() => setExpanded(v => !v)}
      >
        <span className="plusminus" aria-hidden="true">
          {expanded ? "−" : "+"}
        </span>
        <span className="toggle-text">{expanded ? "Read Less" : "Read More"}</span>
      </button>

      {expanded && (
        <p id={contentId} className="bio">
          {bio}
        </p>
      )}
    </div>
  );
};

export default FounderBox;
